export default __webpack_public_path__ + "static/media/choose1.12dfbb85.svg";